<!-- <mat-toolbar>
    <span><b>Candidate Details</b></span>
    <span class="fill-remaining-space"></span>
    <button class="close" (click)='onClose()'>
        <mat-icon>close</mat-icon>
    </button>
</mat-toolbar> -->

<mat-toolbar class="toolbar-example">
    <span>Candidate Details</span>
    <span class="fill-remaining-space"></span>
    <mat-icon style="cursor: pointer;" (click)='onClose()'>close</mat-icon>
</mat-toolbar>

<div class="container">
    <mat-card class="profile-pic-card">
        <div class="profile-pic">
            <img mat-card-image src="./assets/img/profile.png" alt="Photo of {{candidateDetails?.candidateName}}">
        </div>
        <mat-card-title>{{candidateDetails?.candidateName}}</mat-card-title>
    </mat-card>
    <mat-card class="candidate-details">
        <table>
            <tr>
                <td>Candidate Name:</td>
                <td>{{candidateDetails?.candidateName}}</td>
            </tr>
            <tr>
                <td>Candidate Email-Id:</td>
                <td>{{candidateDetails?.email}}</td>
            </tr>
            <tr>
                <td>Contact No.:</td>
                <td>{{candidateDetails?.contactNo}}</td>
            </tr>
            <tr>
                <td>Gender:</td>
                <td>{{candidateDetails?.gender}}</td>
            </tr>
            <tr>
                <td>Address:</td>
                <td>{{candidateDetails?.address}}</td>
            </tr>
            <tr>
                <td>Secured Scores in Screening Test:</td>
                <td>{{candidateDetails?.score}}</td>
            </tr>
            <tr>
                <td>Attempt Status:</td>
                <td>{{candidateDetails?.attemptStatus}}</td>
            </tr>
            <!-- <tr>
                <td>ReportUrl:</td>
                <td>{{candidateDetails.reportUrl}}</td>
            </tr>
            <tr>
                <td>Resume:</td>
                <td>{{candidateDetails.resume}}</td>
            </tr> -->
        </table>
        <mat-expansion-panel style="background: lightgray;">
            <mat-expansion-panel-header>Previous Processes Feedback:</mat-expansion-panel-header>
            <table style="width:300px">
                
                <!-- <td>{{element.processName}}  :--</td>
                <td>{{feedbackMap.get(candidateId)}}</td> -->

                <tr *ngIf="firstProcess == true">No previous process scheduled.</tr>

                <tr *ngFor="let name of previousProcess; let i = index"> <span *ngIf="firstProcess != true">{{ name }} </span>
                    <td *ngIf="firstProcess != true">:--</td>
                    <td *ngIf="feedbackMap.get(previousProcess[i]) !== null && firstProcess != true"> {{ feedbackMap.get(previousProcess[i]) }}</td>
                    <td *ngIf="feedbackMap.get(previousProcess[i]) === null && firstProcess != true">  NA </td>
                </tr> 
            </table>
        </mat-expansion-panel>
    </mat-card>
</div>